/*
 * Per-conversation message drafts, persisted to localStorage. Pure wrapper — no
 * Preact / no store deps — and fail-safe: any storage error (disabled, full,
 * private mode) degrades to a no-op so composing never breaks. `storage` is
 * injectable for tests; defaults to window.localStorage.
 */

const PREFIX = 'keepspot.inboxDraft.';

function resolveStorage(storage) {
    if (storage) {
        return storage;
    }
    try {
        return typeof window !== 'undefined' ? window.localStorage : null;
    } catch (e) {
        return null;
    }
}

// The saved draft for a conversation, or '' if none / unavailable.
export function getDraft(convKey, storage) {
    const s = resolveStorage(storage);
    if (!s || !convKey) {
        return '';
    }
    try {
        return s.getItem(PREFIX + convKey) || '';
    } catch (e) {
        return '';
    }
}

// Save a draft. Blank / whitespace-only text clears it instead of storing blank.
export function setDraft(convKey, text, storage) {
    const s = resolveStorage(storage);
    if (!s || !convKey) {
        return;
    }
    try {
        if (!text || !text.trim()) {
            s.removeItem(PREFIX + convKey);
        } else {
            s.setItem(PREFIX + convKey, text);
        }
    } catch (e) {
        // quota / disabled — ignore
    }
}

// Remove a draft for a conversation.
export function clearDraft(convKey, storage) {
    const s = resolveStorage(storage);
    if (!s || !convKey) {
        return;
    }
    try {
        s.removeItem(PREFIX + convKey);
    } catch (e) {
        // ignore
    }
}
